import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import InputContainer from "./InputContainer";
import Icon from "./Icon";
var propTypes = {
  /** application theme */
  theme: PropTypes.shape({
    formInputIcon: PropTypes.oneOf(['dark'])
  }),
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  children: PropTypes.node
};
var defaultProps = {
  theme: {}
};
export function FormInputIcon(_ref) {
  var theme = _ref.theme,
      icon = _ref.icon,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["theme", "icon", "children"]);

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(InputContainer, props, children, icon && React.createElement(Icon, {
    icon: icon
  })));
}
FormInputIcon.darkTheme = {
  formInputIcon: 'dark'
};
FormInputIcon.propTypes = propTypes;
FormInputIcon.defaultProps = defaultProps;
export default FormInputIcon;